<script setup lang="ts">
import { getVersion } from '@/domains/common/services/packageJsonHelper';
</script>

<template>
    <div class="absolute bottom-8 left-8 text-sm text-gray-400">
        {{ getVersion() }}
    </div>
</template>
